import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=64976f22&scoped=true&"
import script from "./TransferModal.vue?vue&type=script&lang=ts&"
export * from "./TransferModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransferModal.vue?vue&type=style&index=0&id=64976f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64976f22",
  null
  
)

export default component.exports